// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1UzX4","left":"InfoRow_left__3w0A2"};